Ext.define('SA.ExportConfig', {
    constructor({model}) {
        this.model = model;
    },

    canHideWindow() {
        return !this.limitCheck || this.limitCheck.canHideWindow();
    },

    getParams() {
        var {resource, model, params} = this;

        return {resource, model, params};
    },

    getUnsupportedFormats() {
        return this.excelOnly ? ['csv', 'zip'] : [];
    },

    isTable() {
        return this.resource !== 'chart';
    },

    async onLimitCheckReady(cb) {
        await this.prepare();

        var canExport = this.limitCheck.canExport(),
            messageOrNull = this.limitCheck.maybeGetMessage();

        cb({canExport, messageOrNull});
    }
});